var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounSearch7865280(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m476.44 65.344c-229.69 0-415.82 186.19-415.82 415.82 0 229.69 186.14 415.87 415.82 415.87 89.062 0 171.61-28.031 239.29-75.75l292.45 292.5c27.844 27.797 72.984 27.797 100.83 0 27.844-27.844 27.844-72.984 0-100.83l-292.45-292.45c47.672-67.688 75.703-150.24 75.703-239.34 0-229.64-186.19-415.82-415.82-415.82zm-273.28 415.82c0-150.89 122.34-273.24 273.28-273.24s273.28 122.34 273.28 273.24c0 150.94-122.34 273.28-273.28 273.28s-273.28-122.34-273.28-273.28z",
    fill: "#94A3B8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounSearch7865280);
export default __webpack_public_path__ + "static/media/noun-search-7865280.0395dab921ba9b5f2b9ad1450a881e1d.svg";
export { ForwardRef as ReactComponent };